var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgManageCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.66797 3.33337C5.5634 3.33337 4.66797 4.2288 4.66797 5.33337V8.00004C3.5634 8.00004 2.66797 8.89547 2.66797 10V14.6667C2.66797 15.7713 3.5634 16.6667 4.66797 16.6667H13.3346C14.4392 16.6667 15.3346 15.7713 15.3346 14.6667V12C16.4392 12 17.3346 11.1046 17.3346 10V5.33337C17.3346 4.2288 16.4392 3.33337 15.3346 3.33337H6.66797ZM15.3346 10.6667C15.7028 10.6667 16.0013 10.3682 16.0013 10V7.33337H6.0013V8.00004H13.3346C14.4392 8.00004 15.3346 8.89547 15.3346 10V10.6667ZM6.0013 6.00004H16.0013V5.33337C16.0013 4.96518 15.7028 4.66671 15.3346 4.66671H6.66797C6.29978 4.66671 6.0013 4.96518 6.0013 5.33337V6.00004ZM4.66797 9.33337C4.29978 9.33337 4.0013 9.63185 4.0013 10V10.6667H14.0013V10C14.0013 9.63185 13.7028 9.33337 13.3346 9.33337H4.66797ZM4.0013 14.6667V12H14.0013V14.6667C14.0013 15.0349 13.7028 15.3334 13.3346 15.3334H4.66797C4.29978 15.3334 4.0013 15.0349 4.0013 14.6667Z",
    fill: "currentColor",
    fillOpacity: 0.72
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManageCard);
export default __webpack_public_path__ + "static/media/manage-card.f59f256e3147188720a2cdb855ca47ee.svg";
export { ForwardRef as ReactComponent };